export default __webpack_public_path__ + "static/media/uixd.d6b66298.svg";